export default __webpack_public_path__ + "static/media/marker.ee14cbc1.png";